/**
 * Namespaces or tools therefor.
 * @module namespaces
 * @license MIT
*/


/**
* Common namepaces constants in alpha order.
* @enum {string}
* @type {PlainObject}
* @memberof module:namespaces
*/
export enum NS {
    HTML = 'http://www.w3.org/1999/xhtml',
    MATH = 'http://www.w3.org/1998/Math/MathML',
    SE = 'http://svg-edit.googlecode.com',
    SVG = 'http://www.w3.org/2000/svg',
    XLINK = 'http://www.w3.org/1999/xlink',
    OI = 'http://www.optimistik.fr/namespace/svg/OIdata',
    XML = 'http://www.w3.org/XML/1998/namespace',
    XMLNS = 'http://www.w3.org/2000/xmlns/', // see http://www.w3.org/TR/REC-xml-names/#xmlReserved
    PD = 'https://trident-zen.com',
    ZAA = 'http://ns.sonoco-trident.com/xmp/zaa',

    // Illustrator namespaces

    A = 'http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/',
    I = 'http://ns.adobe.com/AdobeIllustrator/10.0/',
    PDF = 'http://ns.adobe.com/pdf/1.3/',
    RDF = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#',
    X = 'http://ns.adobe.com/Extensibility/1.0/',
    X_Alias = 'adobe:ns:meta/',
    XMP = 'http://ns.adobe.com/xap/1.0/',
    XMP_GIMG = 'http://ns.adobe.com/xap/1.0/g/img/',
    XMP_MM = 'http://ns.adobe.com/xap/1.0/mm/',
    XMP_TPG = 'http://ns.adobe.com/xap/1.0/t/pg/',
    XMP_G = 'http://ns.adobe.com/xap/1.0/g/',
    ILLUSTRATOR = 'http://ns.adobe.com/illustrator/1.0/',
    ST_EVT = 'http://ns.adobe.com/xap/1.0/sType/ResourceEvent#',
    ST_REF = 'http://ns.adobe.com/xap/1.0/sType/ResourceRef#',
    ST_MFS = 'http://ns.adobe.com/xap/1.0/sType/ManifestItem#',
    ST_DIM = 'http://ns.adobe.com/xap/1.0/sType/Dimensions#',
    ST_FNT = 'http://ns.adobe.com/xap/1.0/sType/Font#',
    AWL = 'http://www.3ds.com/#copyartwork:awl',
    EXTENSIS_FONT_SENSE = 'http://www.extensis.com/meta/FontSense/',
    DC = 'http://purl.org/dc/elements/1.1/',
    MERCURY_SPECIFIC = 'http://ns.Mercury.com/xmp/1.0/',
    MERCURY_ESKO = 'http://ns.Mercury.com/xmp/esko/1.0/',
    EG_GR = 'http://ns.esko-graphics.com/grinfo/1.0/',
    EG_INK = 'http://ns.esko-graphics.com/inkinfo/1.0/',
    EG_INKCOVL = 'http://ns.esko-graphics.com/inkcovlist/1.0/',
    EG_LAYL = 'http://ns.esko-graphics.com/laylist/1.0/',
    EG_LAY = 'http://ns.esko-graphics.com/layer/1.0/',
    EG_EXTFL2 = 'http://ns.esko-graphics.com/extfileslist/2.0/',
    EG_EXTF = 'http://ns.esko-graphics.com/extfile/1.0/',
    EG_EXTFL = 'http://ns.esko-graphics.com/extfileslist/1.0/',
    EG_PAGL = 'http://ns.esko-graphics.com/pagerangelist/1.0/',
    EG_PAG = 'http://ns.esko-graphics.com/pagerange/1.1/',
    EG_FONTL = 'http://ns.esko-graphics.com/fontlist/1.0/',
    EG_FONT = 'http://ns.esko-graphics.com/fontinfo/1.0/',
}


type ReverseNSCollection = {
    [key in (typeof NS)[keyof typeof NS]]: string;
};
/**
* @function module:namespaces.getReverseNS
* @returns {string} The NS with key values switched and lowercase
*/
export const getReverseNS = function () {
    const reverseNS: ReverseNSCollection = {} as any;
    Object.entries(NS).forEach(([name, URI]) => {
        reverseNS[URI] = name.toLowerCase();
    });
    return reverseNS;
};
